import firebase from "firebase";

var firebaseConfig = {
    apiKey: "AIzaSyBgQxZvEAuTIsdNVJK_Qo_AAZeYOZ7ryyo",
    authDomain: "sarawak-dch.firebaseapp.com",
    databaseURL: "https://sarawak-dch.firebaseio.com",
    projectId: "sarawak-dch",
    storageBucket: "sarawak-dch.appspot.com",
    messagingSenderId: "660461336202",
    appId: "1:660461336202:web:6b0945a670537a36851f73",
    measurementId: "G-ZMC0QB4FWB"
  };
  // Initialize Firebase
  var fireDb = firebase.initializeApp(firebaseConfig);

  export default fireDb.database().ref();
  export const myStorage = firebase.storage()

/*  firebase.initializeApp(config)
firebase.firestore().settings({
    timestampsInSnapshots: true
})

export const myFirebase = firebase
export const myFirestore = firebase.firestore()
export const myStorage = firebase.storage() */